import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AuthService from '../../services/auth.service';

let user = {};
let token = '';
try {
  user = JSON.parse(localStorage.getItem('user'));
  token = JSON.parse(localStorage.getItem('user_token'))?.token || '';
} catch (error) {
  user = false;
  token = '';
}

export const login = createAsyncThunk('auth/login', async (params, thunkAPI) => {
  try {
    const data = await AuthService.loginAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getProfile = createAsyncThunk('auth/getProfile', async (params, thunkAPI) => {
  try {
    const data = await AuthService.profileAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateProfile = createAsyncThunk('auth/updateProfile', async (params, thunkAPI) => {
  try {
    const data = await AuthService.updateProfileAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const verifyEmail = createAsyncThunk('auth/verifyEmail', async (params, thunkAPI) => {
  try {
    const data = await AuthService.verifyEmailAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const forgotPassword = createAsyncThunk('auth/forgotPassword', async (params, thunkAPI) => {
  try {
    const data = await AuthService.forgotPasswordAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const changePassword = createAsyncThunk('auth/changePassword', async (params, thunkAPI) => {
  try {
    const data = await AuthService.changePasswordAPI(params);
    return { response: data };
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const logout = createAsyncThunk('auth/logout', async () => {
  await AuthService.logoutAPI();
});

const initialState = user
  ? { isLoggedIn: true, user, token, response: null, profile: null }
  : { isLoggedIn: false, user: null, token: '', response: null };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  extraReducers: {
    [login.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.data;
      state.token = action.payload.data?.token || '';
      localStorage.setItem('userLoginTime', new Date().getTime());
    },
    [login.rejected]: (state, action) => {
      state.isLoggedIn = false;
      state.user = null;
      state.message = action.payload;
    },
    [getProfile.fulfilled]: (state, action) => {
      state.profile = action.payload.data;
    },
    [verifyEmail.fulfilled]: (state, action) => {
      state.profile = action.payload.data;
    },
    // [updateProfile.fulfilled]: (state, action) => {
    //   state.profile = action.payload.data;
    // },
    [logout.fulfilled]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.token = '';
    }
  }
});

const { reducer } = authSlice;
export default reducer;
